require('./RARoboMoreOptionsButton.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

//commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { PopoverMenu } = require('commonsComponents/popoverMenu');

class RARoboMoreOptionsButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleGoToLandingPageOfRobo = this.handleGoToLandingPageOfRobo.bind(
            this,
        );
    }

    handleGoToLandingPageOfRobo() {
        const { history, shouldGoBack, onGoBackButtonClick } = this.props;
        onGoBackButtonClick();
        if (shouldGoBack) {
            history.goBack();
        } else {
            history.push('/myprofile/broker/general/robo');
        }
    }

    render() {
        const { moreOptions, buttonDisabled } = this.props;
        const moreOptionsButton = (
            <OKButton
                modifier="ghost"
                inverse={true}
                rightIcon="icon-dropdown-abrir"
                smallRightIcon={true}
                disabled={buttonDisabled}
            >
                <FormattedText value="accounts-moreOptions" />
            </OKButton>
        );

        const targetElement = (
            <div className="ra-robo-more-options-button__button-margin">
                {moreOptionsButton}
            </div>
        );

        const content = (
            <PopoverMenu
                target={targetElement}
                items={moreOptions}
                placement="bottomRight"
            />
        );

        const actionLinkButton = (
            <span className="ra-robo-more-options-button__back-button">
                <OKButton
                    modifier="ghost"
                    inverse={true}
                    onClick={this.handleGoToLandingPageOfRobo}
                    leftIcon="icon-anterior"
                >
                    <FormattedText value="raRoboMoreOptionsButton-backButton" />
                </OKButton>
            </span>
        );

        return (
            <div>
                {buttonDisabled ? moreOptionsButton : content}
                {actionLinkButton}
            </div>
        );
    }
}

RARoboMoreOptionsButton.propTypes = {
    moreOptions: PropTypes.Array,
    shouldGoBack: PropTypes.bool,
    buttonDisabled: PropTypes.bool,
    onGoBackButtonClick: PropTypes.func,
    history: PropTypes.object.isRequired,
};

RARoboMoreOptionsButton.defaultProps = {
    onGoBackButtonClick: () => {},
};

module.exports = withRouter(RARoboMoreOptionsButton);
